import { Box, TextField, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import WalletChecked from "../../../../../media/images/icons/wallet-checked";
import { useAppSelector } from "../../../../../hooks/useRedux";
import { addCommas, digitsEnToFa } from "@persian-tools/persian-tools";
import InfoFillCircle from "../../../../../media/images/icons/infofill-circle";
import Sinabank from "../../../../../media/images/Sina-bank-logo-Vector 1.svg";
import IdentityCheck from "../../../../../media/images/icons/identity-check";
import CustomButton from "../../../../components/CustomButton";
import CheckCircle from "../../../../../media/images/icons/check-circle";
import CreditCard from "../../../../../media/images/icons/credit-card";
import DolorOutline from "../../../../../media/images/icons/dolor-outline";
import CreditChecked from "../../../../../media/images/icons/credit-check";
import InfoTriangle from "../../../../../media/images/icons/info-triangle";

export default function NewRequest() {
  const [checkoutValue, setCheckoutValue] = useState("");

  const themeMode = useAppSelector((state) => state.settings.themeMode);

  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          paddingX: "6px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px 8px",
              backgroundColor: "success.light",
              borderRadius: "5px",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "2px",
              }}
            >
              <WalletChecked size={18} color={theme.palette.success.main} />
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "700",
                  color: themeMode === "dark" ? "#fff" : "textColor.main",
                }}
              >
                جمع کل کرایه بار(قابل برداشت):
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "3px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                }}
                color={"success.main"}
              >
                {digitsEnToFa(addCommas(850000000))}
              </Typography>
              <Typography variant="h6">ریال</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          paddingX: "6px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <DolorOutline size={18} color={theme.palette.textColor.main} />
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            مقدار درخواست برداشت
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            borderColor: "textColor.light",
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: "10px",
          }}
        >
          <TextField
            placeholder="مقدار برداشت را به ریال وارد کنید "
            type="tel"
            value={checkoutValue}
            onChange={(e) => {
              const value = addCommas(e.target.value);

              console.log(value);

              setCheckoutValue(digitsEnToFa(value));
            }}
            sx={{
              flex: 1,
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none !important",
                outline: "none !important",
              },
              "& .MuiInputBase-input": {
                textAlign: "right",
                border: "none !important",
                outline: "none !important",
                fontSize: "12px",
                padding: "12px 12px",
              },
              "& .MuiInputBase-root": {
                border: "none !important",
                outline: "none !important",
              },
              border: "none",
            }}
          />
          <Box
            sx={{
              borderRight: "solid",
              borderColor: "textColor.light",
              borderWidth: "1px",
              height: "41.5px",
              display: "flex",
              alignItems: "center",
              paddingX: "4px",
              backgroundColor: "",
            }}
          >
            <Typography>ریال</Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <InfoFillCircle size={20} color={theme.palette.secondary.main} />
          <Typography
            sx={{
              fontSize: "14px",
              color: theme.palette.secondary.main,
            }}
          >
            حداقل مقدار برداشت {digitsEnToFa(addCommas(1000000))} ریال است
          </Typography>
        </Box>

        <Box
          sx={{
            mt: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              justifyContent: "center",
            }}
          >
            <CreditChecked size={18} color={theme.palette.textColor.main} />
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "700",
              }}
            >
              کارت بانکی شما
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 1,
              borderRadius: "10px",
              border: "solid",
              borderColor: "textColor.light",
              borderWidth: "1px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "6px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img width={50} src={Sinabank} alt="" />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "3px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                  color={"primary.main"}
                >
                  رضا یعقوبی فریان‌پور
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "3px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                    }}
                  >
                    بانک ایران زمین
                  </Typography>
                  <Box
                    sx={{
                      width: "fit-content",
                      paddingX: "4px",
                      backgroundColor: "success.light",
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                      paddingY: "2px",
                      borderRadius: "5px",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "50%",
                        backgroundColor: "#fff",
                      }}
                    >
                      <IdentityCheck
                        size={16}
                        color={theme.palette.success.main}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontSize: "12px",
                      }}
                      color={"success.main"}
                    >
                      احراز شده
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
              }}
            >
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "700",
                }}
              >
                10234567890123456
              </Typography>
              <Typography
                sx={{
                  fontSize: "12px",
                }}
              >
                IR 01234567890123456
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            mt: 2,
            // border: "1px solid gray",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <CustomButton
            title="ویرایش حساب"
            bgColor="primary.main"
            justifyContent="center"
            fSize="12px"
            px="6px"
            py="8px"
            borderRadius="6px"
            icon1={<CreditCard size={18} color={"#fff"} />}
          />
          <CustomButton
            flex={1}
            title="تایید مبلغ و ارسال درخواست"
            bgColor="success.main"
            justifyContent="center"
            fSize="12px"
            px="6px"
            py="8px"
            borderRadius="6px"
            icon1={<CheckCircle size={18} color={"#fff"} />}
          />
        </Box>

        <Box
          sx={{
            mt: 1,
            borderWidth: "0.5px",
            borderStyle: "solid",
            borderColor: "info.main",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            padding: "8px",
            borderRadius: "10px",
            backgroundColor: "info.light",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mx: "auto",
              gap: "4px",
            }}
          >
            <InfoTriangle size={18} color={theme.palette.secondary.main} />
            <Typography
              color={"secondary.main"}
              sx={{
                fontSize: "14px",
              }}
            >
              به نکات زیر توجه داشته باشید
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "4px",
            }}
          >
            <InfoFillCircle size={18} color={theme.palette.primary.main} />
            <Typography
              sx={{
                fontSize: "12px",
              }}
            >
              با اعلام حضور، شما یک نوبت در بین دیگر رانندگان بر اساس زمانی
              اعلام حضور می‌کنید دریافت خواهید کردکه{" "}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "4px",
            }}
          >
            <InfoFillCircle size={18} color={theme.palette.primary.main} />
            <Typography
              sx={{
                fontSize: "12px",
              }}
            >
              با اعلام حضور، شما یک نوبت در بین دیگر رانندگان بر اساس زمانی
              اعلام حضور می‌کنید دریافت خواهید کردکه{" "}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "4px",
            }}
          >
            <InfoFillCircle size={18} color={theme.palette.primary.main} />
            <Typography
              sx={{
                fontSize: "12px",
              }}
            >
              با اعلام حضور، شما یک نوبت در بین دیگر رانندگان بر اساس زمانی
              اعلام حضور می‌کنید دریافت خواهید کردکه{" "}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
